import './booking-brand.css';

interface BookingStepProgressProps {
  /** Paso actual, 1-indexado. */
  current: 1 | 2 | 3;
  /** Etiqueta "Paso N de 3". */
  stepLabel: string;
  /** Titular grande del paso ("¿Qué necesitas?"). */
  title: string;
  total?: number;
}

/**
 * Cabecera de paso del flujo de reserva: barra segmentada + "Paso N de 3" + titular.
 * Es la única pieza que comunica cuánto queda, así que se repite idéntica en los tres pasos.
 */
export function BookingStepProgress({ current, stepLabel, title, total = 3 }: BookingStepProgressProps) {
  return (
    <div className="bk-step-head">
      <div className="bk-step-bar" role="progressbar" aria-valuenow={current} aria-valuemin={1} aria-valuemax={total}>
        {Array.from({ length: total }, (_, i) => (
          <span key={i} className={`bk-step-bar-seg${i < current ? ' bk-step-bar-seg--done' : ''}`} />
        ))}
      </div>
      <p className="bk-step-eyebrow">{stepLabel}</p>
      <h2 className="bk-step-title">{title}</h2>
    </div>
  );
}
